import { BACKEND_ROUTES } from "../../backendRoutes";
import useSWRImmutable from "swr/immutable";

export const usePresets = () =>
    useSWRImmutable(`${BACKEND_ROUTES.PRESET}?traits=true`);
